import { useEffect } from 'react';

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isArray, truncate } from 'lodash';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useSearch } from '../../../contexts/SearchContext';
import { sentenceCase } from '../../../utils/utils';
import Loading from '../../elements/loading/Loading';

const StyledPaper = styled(Table)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
}));

const FieldTable = ({ docKey }) => {
  const { t } = useTranslation();

  const {
    query,
    isLoadingStoredFields,
    storedFields,
    fetchStoredFields,
    clearStoreFields,
  } = useSearch();
  const { uniqueKey } = query;

  useEffect(() => {
    fetchStoredFields(`${uniqueKey}:"${docKey}"`);

    return () => clearStoreFields();
  }, []);

  return (
    <TableContainer
      component={Paper}
      style={{ maxHeight: 400, minWidth: 200, maxWidth: 500, padding: 0 }}
    >
      {isLoadingStoredFields ? (
        <Loading />
      ) : storedFields ? (
        <StyledPaper size="small" aria-label="field table" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>{t('solrField', { ns: 'instance' })}</TableCell>
              <TableCell>{t('solrValue', { ns: 'instance' })}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.keys(storedFields).map((key) => (
              <TableRow key={key}>
                <TableCell align="left" style={{ minWidth: 80 }}>
                  {key}
                </TableCell>
                <TableCell align="left">
                  {isArray(storedFields[key])
                    ? truncate(storedFields[key].join('\n'), { length: 30 })
                    : storedFields[key].toString()}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </StyledPaper>
      ) : (
        <Box sx={{ m: 2 }}>
          <Alert variant="outlined" severity="error">
            {sentenceCase(
              t('loading', {
                ns: 'errors',
                content: t('storedFields', { ns: 'instance' }),
              })
            )}
          </Alert>
        </Box>
      )}
    </TableContainer>
  );
};

FieldTable.propTypes = {
  docKey: PropTypes.string,
};

export default FieldTable;
